/**
 * Gray Contracting Business Configuration
 * Verified business facts for SEO and content
 * Do not hard-code unverifiable claims throughout components
 */

export const businessConfig = {
  // Basic Business Info
  legalName: "Gray Contracting",
  displayName: "Gray Contracting",
  phone: "214-908-7644",
  phoneFormatted: "(214) 908-7644",
  phoneTel: "+12149087644",
  email: "c.graycontracting@gmail.com",
  
  // Address
  address: {
    street: "4300 N Central Expy",
    city: "Dallas",
    state: "TX",
    zip: "75206",
    country: "US",
    full: "4300 N Central Expy, Dallas, TX 75206"
  },
  
  // Website
  domain: "graycontractingdfw.com",
  baseUrl: "https://graycontractingdfw.com",
  
  // Licensing - VERIFIED
  moldLicense: {
    number: "1776",
    type: "Texas Mold Remediation Company",
    verificationUrl: "https://www.tdlr.texas.gov/mld/",
    isVerified: true
  },
  
  // Experience
  yearsInBusiness: "55+",
  establishedYear: 1969,
  
  // Service Areas - Verified
  serviceAreas: [
    "Dallas",
    "Plano", 
    "Richardson",
    "Garland",
    "Mesquite",
    "Irving",
    "Frisco",
    "Rockwall",
    "Heath",
    "Southlake",
    "Grapevine",
    "Colleyville",
    "Allen",
    "McKinney",
    "Carrollton"
  ],
  
  // Property Types Served
  propertyTypes: ["Residential", "Commercial", "Multi-Family"],
  
  // Trust Signals - Only verified claims
  trustSignals: [
    "Texas Mold Remediation License #1776",
    "Fully Insured",
    "55+ Years in Contracting",
    "Family-Owned and Operated",
    "Residential & Commercial",
    "Remediation + Reconstruction"
  ],
  
  // Social/Tracking
  analytics: {
    ga4Id: "G-1T3D6ECH49",
    gtmId: null // Add when available
  }
};

// Mold-specific content configuration
export const moldConfig = {
  // SEO Metadata
  seo: {
    title: "Mold Remediation Dallas, TX | Mold Removal | Gray Contracting",
    titleLicensed: "Licensed Mold Remediation Dallas, TX | Gray Contracting",
    description: "Professional mold remediation and reconstruction in Dallas–Fort Worth. Texas License #1776. Request an estimate from Gray Contracting or call 214-908-7644.",
    canonical: "/services/mold-remediation",
    keywords: "mold remediation Dallas, mold removal Dallas TX, mold testing Dallas, black mold removal Dallas, mold remediation Fort Worth, attic mold remediation Dallas, licensed mold remediation Texas"
  },
  
  // Hero Content
  hero: {
    eyebrow: "Dallas–Fort Worth Mold Remediation",
    h1: "Mold Remediation in Dallas, TX",
    intro: "Gray Contracting provides mold remediation and post-remediation reconstruction for homes and commercial properties across Dallas–Fort Worth. We contain affected areas, remove contaminated building materials according to the project protocol, and repair the drywall, trim, flooring, paint, and finishes damaged during the work.",
    primaryCta: "Request a Mold Remediation Estimate",
    secondaryCta: "Call 214-908-7644"
  },
  
  // Project Images - Before/After
  projectImages: {
    bathroom: {
      before: "https://static.prod-images.emergentagent.com/jobs/5a35076f-aa67-447c-9eac-34696923d44e/images/760426930cbca63b2da807684cdd42e33eb8ba0e4fdfa12269c8993c7528c756.jpeg",
      after: "https://static.prod-images.emergentagent.com/jobs/5a35076f-aa67-447c-9eac-34696923d44e/images/a20bfbd487595b4f009afb4e5bb6f455e3b6f020b66bdd06c774b4a1b82a4b56.jpeg",
      altBefore: "Severe black mold growth on bathroom walls and ceiling near shower area requiring professional remediation",
      altAfter: "Clean renovated bathroom after complete mold remediation and reconstruction by Gray Contracting",
      location: "Dallas",
      propertyType: "Residential"
    },
    attic: {
      before: "https://static.prod-images.emergentagent.com/jobs/5a35076f-aa67-447c-9eac-34696923d44e/images/312b55b7d1c492b93e2e3cbf2c6a434d336398357e4bc21211801b06c107200b.jpeg",
      after: "https://static.prod-images.emergentagent.com/jobs/5a35076f-aa67-447c-9eac-34696923d44e/images/46481b9ba5838397ff2b2eb10b6e655019c4d3207507c9a2cb2cfa440beb12bc.jpeg",
      altBefore: "Extensive mold growth on attic rafters and roof sheathing from roof leak requiring remediation",
      altAfter: "Clean treated attic space after mold remediation with fresh wood treatment",
      location: "Lake Highlands",
      propertyType: "Residential"
    },
    wall: {
      before: "https://static.prod-images.emergentagent.com/jobs/5a35076f-aa67-447c-9eac-34696923d44e/images/820a8f14f3f9030c2e5244705ecf7711b96007a7bebedc932dcb2abf0996a6cd.jpeg",
      after: "https://static.prod-images.emergentagent.com/jobs/5a35076f-aa67-447c-9eac-34696923d44e/images/3dfbe075f35da784e9769cd5e64240a9f60daae36cb35d50d45c121b9815224c.jpeg",
      altBefore: "Hidden mold contamination behind drywall on wooden studs and insulation",
      altAfter: "Clean wall cavity with treated studs and new insulation ready for drywall",
      location: "Richardson",
      propertyType: "Residential"
    }
  },
  
  // Services Offered
  services: [
    { title: "Mold Remediation", desc: "Professional containment, removal, and treatment of mold-contaminated materials" },
    { title: "Mold Testing & Inspection", desc: "Comprehensive assessment to identify mold presence and extent" },
    { title: "Containment & Negative Air", desc: "Isolation of work areas with engineering controls" },
    { title: "HEPA Air Filtration", desc: "Professional air scrubbing and HEPA vacuuming" },
    { title: "Attic Mold Remediation", desc: "Address mold caused by roof leaks or poor ventilation" },
    { title: "Wall Cavity Remediation", desc: "Detection and removal of hidden mold growth" },
    { title: "Bathroom & Kitchen Mold", desc: "Remediation of high-moisture area contamination" },
    { title: "Commercial Remediation", desc: "Solutions for offices, warehouses, and commercial buildings" },
    { title: "Post-Clearance Reconstruction", desc: "Drywall, paint, and finish repairs after clearance" }
  ],
  
  // Remediation Process Steps
  process: [
    {
      step: 1,
      title: "Initial Call & Document Review",
      description: "Collect the customer's concern, property details, photos, and existing assessment or protocol."
    },
    {
      step: 2,
      title: "Independent Assessment",
      description: "A Texas-licensed Mold Assessment Consultant defines the affected area and remediation protocol when required."
    },
    {
      step: 3,
      title: "Remediation Proposal",
      description: "Gray reviews the protocol and provides a scope, schedule, and estimate for the remediation work."
    },
    {
      step: 4,
      title: "Containment Setup",
      description: "The crew isolates the work area and establishes protocol-required engineering controls including negative air."
    },
    {
      step: 5,
      title: "Removal & Cleaning",
      description: "Contaminated materials are safely removed and remaining materials are cleaned according to the protocol."
    },
    {
      step: 6,
      title: "Independent Clearance",
      description: "The assessment professional evaluates the completed remediation when required for post-remediation verification."
    },
    {
      step: 7,
      title: "Reconstruction",
      description: "After clearance, Gray repairs the affected drywall, trim, flooring, paint, and other approved finishes."
    }
  ],
  
  // Texas-Compliant FAQs
  faqs: [
    {
      q: "What is the difference between mold assessment and mold remediation in Texas?",
      a: "Texas separates mold assessment from mold remediation on regulated projects. A licensed Mold Assessment Consultant evaluates the property and prepares the remediation protocol. The remediation contractor performs the work described in that protocol. The assessment professional then performs post-remediation clearance when required. Gray Contracting is licensed for remediation (License #1776) but does not perform both assessment and remediation on the same regulated project."
    },
    {
      q: "Do I need a mold remediation protocol before calling Gray?",
      a: "Not necessarily. If you don't have an assessment or protocol yet, we can explain the appropriate next step. For projects requiring a protocol under Texas regulations, we can discuss options for obtaining one from an independent licensed assessor."
    },
    {
      q: "Can Gray Contracting test for mold and remediate the same project?",
      a: "For regulated projects in Texas, the same company cannot perform both assessment and remediation. Gray Contracting provides remediation services. If you need testing or assessment, we can explain how to work with an independent licensed Mold Assessment Consultant."
    },
    {
      q: "How long does mold remediation take?",
      a: "The timeline depends on the size of the affected area, containment requirements, materials being removed, drying conditions, and whether reconstruction is included. Some localized projects can be completed in several working days, while larger projects take longer. We provide a realistic schedule after reviewing the project scope."
    },
    {
      q: "Can I remain in my home during remediation?",
      a: "That depends on the project location, affected area, containment plan, and the needs of the occupants. Some projects can be isolated while other areas remain accessible. Larger or more disruptive projects may require temporary relocation. The project team will explain access restrictions before work begins."
    },
    {
      q: "What happens to mold-damaged drywall and insulation?",
      a: "Drywall and insulation are porous materials and may need to be removed when contamination extends into the material. The decision depends on the condition and the remediation protocol. After remediation and clearance, Gray Contracting can replace affected drywall, insulation, and finishes."
    },
    {
      q: "Who performs post-remediation clearance?",
      a: "For regulated projects, clearance must be performed by an independent licensed Mold Assessment Consultant—not the remediation contractor. This ensures an objective evaluation that the remediation was successful."
    },
    {
      q: "Can Gray rebuild the area after clearance?",
      a: "Yes. Gray Contracting provides post-remediation reconstruction including drywall replacement, texture matching, painting, trim work, flooring, and other finish repairs. This allows you to work with one contractor from remediation through reconstruction."
    },
    {
      q: "Does homeowners insurance cover mold remediation?",
      a: "Coverage varies by policy and cause of loss. Mold related to a sudden, covered water event may be treated differently from mold caused by a long-term leak, humidity, or deferred maintenance. Contact your insurer for a coverage decision. We can provide project documentation within our scope of work."
    },
    {
      q: "What information should I send when requesting an estimate?",
      a: "Photos of the affected area, any existing assessment or protocol, information about the moisture source, and the property address. If you have inspection reports or insurance documentation, those can also help us understand your situation."
    }
  ]
};

// Schema.org structured data generators
export const generateMoldServiceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": `${businessConfig.baseUrl}/services/mold-remediation#service`,
  "name": "Mold Remediation in Dallas–Fort Worth",
  "url": `${businessConfig.baseUrl}/services/mold-remediation`,
  "serviceType": "Mold remediation and post-remediation reconstruction",
  "description": moldConfig.seo.description,
  "provider": {
    "@id": `${businessConfig.baseUrl}/#business`
  },
  "areaServed": businessConfig.serviceAreas.map(city => ({
    "@type": "City",
    "name": city,
    "containedInPlace": { "@type": "State", "name": "Texas" }
  }))
});

export const generateLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${businessConfig.baseUrl}/#business`,
  "name": businessConfig.displayName,
  "url": businessConfig.baseUrl,
  "telephone": businessConfig.phoneTel,
  "address": {
    "@type": "PostalAddress",
    "streetAddress": businessConfig.address.street,
    "addressLocality": businessConfig.address.city,
    "addressRegion": businessConfig.address.state,
    "postalCode": businessConfig.address.zip,
    "addressCountry": businessConfig.address.country
  },
  "areaServed": businessConfig.serviceAreas
});

export const generateFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.q,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.a
    }
  }))
});

export const generateBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `${businessConfig.baseUrl}${item.path}`
  }))
});

export default businessConfig;
